/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import GridView from '@/views/GridView';
import StringCell from '@/backgrid/StringCell';
import ButtonLinkCell from '@/backgrid/ButtonLinkCell';
import PageableCollection from '@/backbone/PageableCollection';

const CommandDashboardGridView = GridView.extend({
  initialize() {
    (this.options.columns = [
      {
        name: 'dodac',
        label: 'DODAAC',
        cell: StringCell,
        headerCell: 'custom',
        width: 12,
        editable: false,
        sortable: true
      },
      {
        name: 'id',
        label: 'Command ID',
        cell: StringCell,
        headerCell: 'custom',
        width: 12,
        editable: false,
        sortable: true
      },
      {
        name: 'name',
        label: 'Command',
        cell: StringCell,
        headerCell: 'custom',
        width: 25,
        editable: false,
        sortable: true
      },
      {
        name: 'serviceBranchName',
        label: 'Branch',
        cell: StringCell,
        headerCell: 'custom',
        width: 20,
        editable: false,
        sortable: true
      },
      {
        name: 'regionName',
        label: 'Location',
        cell: StringCell,
        headerCell: 'custom',
        width: 15,
        editable: false,
        sortable: true
      },
      {
        name: '',
        label: '',
        editable: false,
        sortable: false,
        cell: ButtonLinkCell.extend({
          name: 'Open',
          buttonClass: 'btn-sm btn-outline-primary',
          href(model) {
            return `#command/${model.get('id')}`;
          },
          newTab: true
        })
      }
    ]),
      (this.collection = new PageableCollection([], { pageSize: 50 }));
    this.options.emptyText = 'No Commands Found';
    GridView.prototype.initialize?.apply(this, this.options);
  }
});

export default CommandDashboardGridView;
